(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define("Main", [
            'jquery',
            'magnificPopup',
            'main.js'
        ], factory);
    } else if (typeof module === 'object' && module.exports) {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory(
            require('jquery'),
            require('magnificPopup'),
            require('main.js')
        );
    } else {
        // Browser globals (root is window)
        root.returnExports = factory(
            root.jquery,
            root.magnificPopup,
            root.main
        );
    }
}(typeof self !== 'undefined' ? self : this, function ($, magnificPopup, main) {
    

    /**
     * Cache
     */
    var doms = {
        galleryTrigger: '.js-gallery-item'
    };
    
    /**
     * Listen gallery events
    */
    var eventHandler = function () {
        $(document).on('click', doms.galleryTrigger, function (e) {
            e.preventDefault();
            getImages($(this));
        });
    };

    /**
     * 
     * @param { $item: trigger item}  
     */
    var getImages = function ($item) {

        var albumId = $item.data('album-id');

        $.ajax({
            url: window.location.origin + "/galeria.json",
            type: "GET",
            data: { "albumID": albumId },
            dataType: 'json',
            success: function (data) {
                initPlugin(data);
            },
            error: function (xhr, status, error) {
                console.log(error);
            }
        });
    };

    var initPlugin = function (data) {

        if (!data || data.length === 0) {
            return false;        
        }

        $.magnificPopup.open({
            type: 'image',
            tLoading: '',
            items: data,
            image: {
                markup: 
                    '<div class="mfp-title"></div>' +
                    '<div class="mfp-figure">' +
                    '<div class="mfp-close"></div>' +
                    '<div class="mfp-img-holder">' +
                    '<div class="mfp-img"></div>' +
                    '</div>' +
                    '</div>' +
                    '<div class="mfp-desc"></div>' +
                    '<div class="mfp-bottom-bar">' +
                    '<div class="mfp-counter"></div>' +
                    '</div>',

                cursor: 'mfp-zoom-out-cur', // Class that adds zoom cursor, will be added to body. Set to null to disable zoom out cursor.
                titleSrc: function(item) {
                    return data[this.index].title
                },
                verticalFit: true // Fits image in area vertically
            },
            gallery: {
                enabled: true,
                arrowMarkup: '<button title="%title%" class="mfp-arrow mfp-arrow-%dir%"><span><i class="icon icon-arrow-%dir% mfp-prevent-close"></i></span></button>',
                tPrev: window.serverVariables.languageData.previous, // title for left button
                tNext: window.serverVariables.languageData.next,
                tCounter: '<span class="mfp-counter"><span class="current">%curr% /</span> <span class="total">%total%</span></span>'
            },
            removalDelay: 300,
            mainClass: 'cs-mfp-fade cs-mfp',
            closeMarkup: '<div class="mfp-close"><button type="button"><span class="mfp-close-icon"><i class="icon icon-close"></i></span><span class="mfp-close-text">'+ window.serverVariables.languageData.close + '</span></button></div>',
            midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
            overflowY: 'auto',
            fixedContentPos: true,
            callbacks: {
                buildControls: function() {
                    this.contentContainer.append(this.arrowLeft.add(this.arrowRight));
                },
                open: function() {
                    $(document).on('click', '.mfp-close', function (e) { 
                        e.preventDefault();
                        $.magnificPopup.close();
                    });
                },
                change: function() {
                    $(this.content[0]).text(data[this.index].title);
                    $(this.content[2]).text(data[this.index].description);
                }
            }
        });
    };

    var init = function () {
        eventHandler();
    };

    init();


    /* set gallery bg from img tags */
    

}));


//////////////////
// WEBPACK FOOTER
// ./js/pages/gallery/index.js
// module id = 27
// module chunks = 3